import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FAQSection from '@/pages/home/components/FAQSection';
import ContactSection from '@/pages/home/components/ContactSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import MediaSection from '@/pages/home/components/MediaSection';
import RankingSection from '@/pages/home/components/RankingSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <FAQSection />
        <ContactSection />
        <TopicsSection />
        <CommentsSection />
        <UpdatesSection />
        <CardsSection />
        <IndexSection />
        <FeaturesSection />
        <AboutSection />
        <AppSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}